import fetchFactory from '../../../utils/fetchFactory'

export const getBourseForm = () => fetchFactory('/api/bourse_form')
